import mapboxgl from 'mapbox-gl';

$(function () {
    window.initMapbox = function () {
        const settings = {
            mapboxElement: '.mapbox',
            markerElement: '.mapbox__marker',
            accessToken: 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNrdmIwMjl0ZzA3MW4ydXFucGt1cnp3OWcifQ.Ox_naZa81hUXwBCrLXK0hA',
            styleLink: 'mapbox://styles/blackdesk/ckq9m676a0skt18nuuc93knpv',
            markerBackgroundImage: '/wp-content/themes/prisma/resources/images/mapbox-pinner.svg',
            markerBackgroundImageSize: 50,
        };

        const mapbox = $(settings.mapboxElement);
        if (!mapbox.length) {
            return;
        }

        const centerLng = mapbox.data('lng');
        const centerLat = mapbox.data('lat');

        if (!centerLng || !centerLat) {
            return;
        }

        mapboxgl.accessToken = settings.accessToken;
        const map = new mapboxgl.Map({
            container: mapbox.get(0),
            style: settings.styleLink,
            center: new mapboxgl.LngLat(centerLng, centerLat),
            maxZoom: 18,
            zoom: 9,
            minZoom: 6,
        });

        const markers = $(settings.mapboxElement + ' ' + settings.markerElement);
        markers.each(function () {
            const marker = document.createElement('div');
            const markerPosition = new mapboxgl.LngLat($(this).data('lng'), $(this).data('lat'));

            let markerBackgroundImage = settings.markerBackgroundImage;
            let markerBackgroundImageSize = settings.markerBackgroundImageSize;

            marker.className = 'marker';
            marker.style.backgroundImage = 'url(' + markerBackgroundImage + ')';
            marker.style.width = markerBackgroundImageSize + 'px';
            marker.style.height = markerBackgroundImageSize + 'px';
            marker.style.top = '-' + markerBackgroundImageSize / 2 + 'px';
            marker.style.backgroundSize = 'contain';
            marker.style.backgroundRepeat = 'no-repeat';
            marker.style.backgroundPosition = 'center bottom';
            new mapboxgl.Marker(marker).setLngLat(markerPosition).addTo(map);

            // Popup maken
            const html = $(this).html();
            if (html) {
                $(marker).on('click', function (event) {
                    event.stopPropagation();
                    mapbox.find('.mapboxgl-popup').remove();
                    new mapboxgl.Popup().setLngLat(markerPosition).setHTML(html).addTo(map);
                });
            }
        });
    };
});
